import script from "./FileManagerGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManagerGallery.vue?vue&type=script&setup=true&lang=js"

import "./FileManagerGallery.vue?vue&type=style&index=0&id=7307a719&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7307a719"]])

export default __exports__